import React, { Component, createRef } from 'react';
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../../actions/fillCombo_action';
import { cityActionId, stallTypeActionId, stallListActionId, countryActionId, exhibitionActionId, toastError, BASE_URL, toastSuccess } from "../../../../utils/constants";
import { companyNameValidator, emailValidator } from "../../../../utils/Validator";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import Pagination from "../../../../utils/pagination";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import { useNavigate } from "react-router-dom";
import ExhibitorDrawer from "../../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../../common_components/exhibitor_module_header";
import { data } from "jquery";
import { getItineraryList_action, delegateItineraryPathAU_action } from "../../../../actions/admin_module_action/delegate_master_action/delegate_Itinerary_action";
import Footer from "../../../../common_components/Footer";
import "pdfjs-dist/build/pdf.worker.entry";
import * as pdfjsLib from "pdfjs-dist";

class DelegateItineraryList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            currentPage: 1,
            DelegateItineraryList: [],
            CompanyName: '',
            exhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            exhibitionList: [],
            Status: 1,
            uploadPop: false,
            itiPath: '',
            itiFile: '',
            itiFiletype: '',
            delId: '',
            delNo: '',

        }
        this.pdfContainerRef = createRef();
        this.updateItem = this.updateItem.bind(this)
        this.onFilePick = this.onFilePick.bind(this)
        this.onPdfSelect = this.onPdfSelect.bind(this)
    }

    componentDidMount() {
        this.getFillList(exhibitionActionId, '', '', '', '', '').then(() => {
            this.getDelegateItineraryList()
        })
    }

    uploadItinenary() {
        const { itiPath,
            itiFile,
            itiFiletype,
            delId,
            delNo, } = this.state
        this.setState({ isLoading: true })
        this.props.delegateItineraryPathAU_action(delId, itiFiletype, delNo, itiFile)
            .then((data) => {
                if (data.error != 1) {
                    this.getDelegateItineraryList()
                    toastSuccess("Submit Successfully")
                    this.setState({
                        uploadPop: false, itiPath: '',
                        itiFile: '',
                        itiFiletype: '',
                    })
                }
            })
    }

    onFilePick = async (e, file) => {
        e.preventDefault()
        const { itiFiletype } = this.state
        console.log('file', file)
        if (file.length != 0) {
            if (file[0]['size'] >= 5 * 1024 * 1024) {
                toastError('File size more than 5mb are not allow.')
            } else {
                var image = '';
                if (file[0]['name'].toString().toLowerCase().includes('.pdf')
                ) {
                    image = await this.onPdfSelect(file[0]);
                    this.setState({ itiFile: image })
                    var fileType = file[0]['type']
                    var fileTypeList;
                    if (fileType.includes("/")) {
                        fileTypeList = fileType.split("/")

                    }
                    this.setState({ itiFiletype: 'pdf' }, () => {
                        this.PdfRender()
                    })
                } else {
                    toastError('Only .pdf , .jpeg, .png, .jpg files are allowed')
                }
            }
        }
    }
    onPdfSelect = (file) =>
        new Promise((resolve) => {
            let base64;
            // FileReader function for read the file.
            let fileReader = new FileReader();
            // Onload of file read the file content
            fileReader.onload = function (fileLoadedEvent) {
                base64 = fileLoadedEvent.target.result;
                // Print data in console
                resolve(base64);
            };
            // Convert data to base64
            fileReader.readAsDataURL(file);
        });

    async PdfRender() {
        const { itiPath, itiFile } = this.state;
        // console.log("IntAreaRules--------------------------------------------->", IntAreaRules)
        // if (!IntRulesPath) return;

        const container = this.pdfContainerRef.current;
        // console.log("container--------------------------------------------->", container)
        if (!container) return;

        container.innerHTML = ""; // clear old pages

        // const url = IntAreaRules
        console.log('itiPath, itiFile', itiPath, itiFile)
        try {
            const url = `${BASE_URL.split("/api")[0]}${itiPath}`;
            var pdf = ''
            if (itiFile != '' && itiFile != null) {
                const base64 = itiFile.split(",")[1];
                // Convert Base64 → Uint8Array
                const binaryString = atob(base64);
                const bytes = new Uint8Array(binaryString.length);
                for (let i = 0; i < binaryString.length; i++) {
                    bytes[i] = binaryString.charCodeAt(i);
                }
                // Load PDF from memory
                pdf = await pdfjsLib.getDocument({
                    data: bytes
                }).promise;
                console.log("Total pages:", pdf.numPages);
            } else {
                pdf = await pdfjsLib.getDocument(url).promise;
            }
            console.log("url--------------------------------------------->", url)
            for (let i = 1; i <= pdf.numPages; i++) {
                const page = await pdf.getPage(i);
                const viewport = page.getViewport({ scale: 1.5 });

                const canvas = document.createElement("canvas");
                const context = canvas.getContext("2d");

                canvas.height = viewport.height;
                canvas.width = viewport.width;
                canvas.style.width = "100%";
                canvas.style.height = "auto";
                canvas.style.display = "block";
                canvas.style.margin = "20px auto";

                container.appendChild(canvas);
                await page.render({ canvasContext: context, viewport }).promise;
            }
        } catch (err) {
            console.error("PDF rendering error:", err);
        }
    }


    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        const { } = this.state
        return new Promise((resolve, reject) => {
            this.setState({ isLoading: true })
            this.props
                .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
                .then((data) => {
                    if (data.error != 1) {
                        // country list
                        if (actionID === exhibitionActionId) {
                            this.setState({
                                exhibitionList: data.data
                            })
                        }
                        resolve(true)
                    }
                    this.setState({ isLoading: false })
                })
                .catch((e) => {
                    console.log(e);
                });
        })
    }

    record(list) {
        return (

            <table class="table border table-bordered mb-0">
                <thead>
                    <tr>
                        <th>Sr.No</th>
                        <th>Company Name</th>
                        <th>Registration no</th>
                        <th>Person No</th>
                        <th>Country</th>
                        <th>Email</th>
                        <th class="text-center">Itinerary</th>
                    </tr>

                </thead>
                <tbody>
                    {
                        list.length > 0 ? <>{
                            list.map((data, i) => (
                                <tr style={{ backgroundColor: data.IsCoordinator ? 'rgb(228 228 228)' : '', borderTop: data.IsCoordinator ? '2px solid #b1b1b1' : '' }}>
                                    <td className="text-center">{data.id}</td>
                                    <td >{data.CompanyName}</td>
                                    <td >{data.DelegateRegistrationNo}</td>
                                    <td >{data.PersonIncharge_FirstName}{' '}{data.PersonIncharge_LastName}</td>
                                    <td >{data.CountryName}</td>
                                    <td >{data.PrimaryEmail}</td>
                                    {data.IsCoordinator ?
                                        <>
                                            {data.ItenaryPath != '' && data.ItenaryPath != null ?
                                                <td class="text-center"><a ><button
                                                    onClick={(e) => this.setState({ uploadPop: true, itiPath: data.ItenaryPath, delId: data.DelegateRegistrationID, delNo: data.DelegateRegistrationNo })}
                                                    type="button" class="btn btn-aqua ad-fil-btn  px-3">Update</button></a>
                                                </td> :
                                                <td class="text-center"><a ><button
                                                    onClick={(e) => this.setState({ uploadPop: true, itiPath: '', delId: data.DelegateRegistrationID, delNo: data.DelegateRegistrationNo })}
                                                    type="button" class="btn btn-aqua px-3">ADD</button></a>
                                                </td>
                                            }
                                        </>
                                        :
                                        <>
                                            {data.isItinerary == 1 ?
                                                <td class="text-center"><a ><button
                                                    onClick={(e) => this.setState({ uploadPop: true, itiPath: data.ItenaryPath, delId: data.DelegateRegistrationID, delNo: data.DelegateRegistrationNo })}
                                                    type="button" class="btn btn-aqua ad-fil-btn  px-3">Update</button></a>
                                                </td> :
                                                <td className="text-center">-</td>
                                            }
                                        </>
                                    }
                                </tr>
                            ))}
                        </> :
                            <tr><td colSpan={13} style={{ textAlign: 'center' }}>Record not found</td></tr>
                    }
                </tbody>
            </table>
        )
    }

    getDelegateItineraryList() {
        const { exhibitionID, CompanyName, Status } = this.state
        this.setState({ isLoading: true })
        this.props.getItineraryList_action(exhibitionID, CompanyName, Status)
            .then((data) => {
                if (data.error != 1) {
                    if (data.data != '') {
                        const array1 = []
                        const array2 = []

                        data.data.map((item) => {
                            if (item.IsCoordinator) {
                                array1.push(item)
                            } else {
                                array2.push(item)
                            }
                        })
                        console.log("array1------>", array1)
                        console.log("array2------>", array2)
                        let output = [];
                        // Loop through the coordinator array (array1)
                        array1.forEach((coordinator, index) => {
                            const coordinatorId = index + 1; // Assign sequential ID
                            // Add the coordinator to the output
                            output.push({ ...coordinator, id: coordinatorId });

                            // Find matching delegates for the coordinator
                            const delegates = array2.filter(delegate => delegate.CoordinatorRegistrationID === coordinator.DelegateRegistrationID);

                            // Loop through the matching delegates and assign sequential sub-IDs
                            delegates.forEach((delegate, subIndex) => {
                                output.push({ ...delegate, id: `${coordinatorId}.${subIndex + 1}` });
                            });
                        });

                        console.log("output------>", output)

                        this.setState({ DelegateItineraryList: output })
                    }
                    this.setState({ isLoading: false, currentPage: 1 })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    clearSearch() {
        const { Stateno, PANNo } = this.state
        this.setState({
            CompanyName: '',
            Status: 1,
            exhibitionID: sessionStorage.getItem("sessionExhibitionID"),
        })
        setTimeout(() => {
            this.getDelegateItineraryList()
        }, 100);
    }

    handleAdd(id, ExhibitionID, IsCoordinator) {
        const { } = this.state
        this.props.navigate('/delegateItineraryAU', { state: { is_add: true, DelegateRegistrationID: id, ExhibitionID: ExhibitionID, parentDelegateRegistrationID: id, IsCoordinator: IsCoordinator } })
    }

    handleUpdate(id, ExhibitionID, CoordinatorRegistrationID, IsCoordinator) {
        const { } = this.state
        this.props.navigate('/delegateItineraryAU', { state: { is_Update: true, DelegateRegistrationID: id, ExhibitionID: ExhibitionID, is_Update: true, childDelegateRegistrationID: id, parentDelegateRegistrationID: CoordinatorRegistrationID, IsCoordinator: IsCoordinator } })
    }


    updateItem(item) {
        const { DelegateItineraryList } = this.state
        this.setState({ currentPage: item });
        const recordsPerPage = 10;
        const indexOfLastRecord = item * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = DelegateItineraryList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(DelegateItineraryList.length / recordsPerPage)
        this.setState({ startIndex: recordsPerPage * (item - 1) });
    }

    render() {
        const { isLoading, currentPage, itiFile, itiFiletype, itiPath, DelegateItineraryList, Status, is_add, CompanyName, uploadPop } = this.state
        const recordsPerPage = 10;
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
        const currentRecords = DelegateItineraryList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(DelegateItineraryList.length / recordsPerPage)
        console.log(itiFiletype)
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                <HeaderWithLogo />

                <>
                    <div className="app-content with-dr-container com-height" style={{ marginTop: '5rem' }}>
                        <AdminDrawer />
                        <div className="row" style={{ marginLeft: '0.3rem' }}>
                            <div className="step-name">
                                <p>Delegate Itinerary</p>
                            </div>
                        </div>
                        <div className="m-3">
                            <div className="">
                                <div className="row ">
                                    <div className="col-md-3">
                                        <label >Exhibition</label>
                                        <select className="form-control"
                                            value={this.state.exhibitionID}
                                            onChange={(e) => this.setState({ exhibitionID: e.target.value })}
                                        >
                                            {
                                                this.state.exhibitionList.length > 0 && this.state.exhibitionList.map((data) => (
                                                    <option key={data.ExhibitionID} value={data.ExhibitionID}>{data.ExhibitionName}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                    <div className="col-md-3">
                                        <label>Company Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={CompanyName}
                                            onChange={(e) => this.setState({ CompanyName: e.target.value, })}
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label>Status</label>
                                        <select className="form-control"
                                            value={Status}
                                            onChange={(e) => this.setState({ Status: e.target.value })}  >
                                            <option value={1}>Active</option>
                                            <option value={0}>Inactive</option>
                                        </select>
                                    </div>
                                    <div className="col-md-3" style={{ textAlign: 'left' }}>
                                        <label>&emsp;</label>
                                        <button type="button" className="btn btn-aqua ad-fil-btn"
                                            onClick={e => this.getDelegateItineraryList()}
                                        >
                                            Search
                                        </button>
                                        <button type="button" className="btn btn-outline-secondary ms-2 ad-fil-btn"
                                            onClick={e => this.clearSearch()}
                                        >
                                            Clear
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 pl-0">
                                <div className="table-responsive mt-3">
                                    {this.record(currentRecords)}
                                </div>
                                <div className="row">
                                    <div className="col-md-9 pl-0">
                                        <div className="mt-2 float">
                                            {
                                                DelegateItineraryList.length > 0 ?
                                                    <Pagination
                                                        nPages={nPages}
                                                        currentPage={currentPage}
                                                        setCurrentPage={this.updateItem}
                                                    /> : <></>
                                            }

                                        </div>
                                    </div>
                                    <div className="col-md-3 text-right">
                                        <div className="tab-rec mt-3" style={{ float: "right" }}>
                                            <p>{`${currentPage} of ${nPages} pages`}</p>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </>
                <Footer />
                <Modal isOpen={uploadPop} onRequestClose={e => this.setState({ uploadPop: !uploadPop })} onAfterOpen={() => this.PdfRender()}>
                    <div className="modal-dialog custom_modal_dialog modal-lg" style={{ left: '0px', top: '115px' }}>
                        <div className="modal-content responsive-width w-auto">
                            <div className="modal-header" style={{ padding: "10px 10px" }}>
                                <h5 className="modal-title" id="termsandconLabel">
                                    <b>Itinerary File</b>
                                </h5>

                                <button style={{ fontSize: '16px' }}
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    // onClick={() => document.getElementById(`file`).click()}
                                    onClick={e => this.setState({
                                        uploadPop: !uploadPop, itiPath: '',
                                        itiFile: '',
                                        itiFiletype: '',
                                    })}
                                />
                            </div>

                            <div className="modal-body" style={{ padding: "0px 12px 9px 12px", height: ((itiFile != '' && itiFile != null) || (itiPath != '' && itiPath != null)) && 'calc(90vh - 200px)', overflow: 'auto', overflowY: 'hidden' }}>
                                {/* <iframe
                                                                                    id="myIframe" style={{ marginTop: '0px' }}
                                                                                    src={`${DOC_BASE_URL + RandRpath}#toolbar=0&navpanes=0`}
                                                                                    width="100%"
                                                                                    height="100%"
                                                                                    title="Bing"
                                                                                /> */}
                                <input
                                    type="file"
                                    id={`file`}
                                    ref={this.fileInputRef}
                                    name={`file`}
                                    class="image-upload"
                                    accept=".pdf"
                                    onChange={e => this.onFilePick(e, e.target.files)}
                                    hidden
                                />
                                <button
                                    type="button"
                                    className="btn btn-aqua mx-2 my-2"
                                    data-bs-dismiss="modal"
                                    style={{ padding: '4px 15px', }}
                                    // onClick={e => this.setState({ uploadPop: false })}
                                    onClick={() => document.getElementById(`file`).click()}
                                >
                                    Upload File
                                </button>
                                {((itiFile != '' && itiFile != null) || (itiPath != '' && itiPath != null)) ? <div
                                    id="pdf-container"
                                    ref={this.pdfContainerRef}
                                    style={{
                                        width: "100%",
                                        height: "100%",       // keeps it scrollable inside card
                                        overflowY: "auto",    // ✅ allow auto scrollbar (not forced scroll)
                                        WebkitOverflowScrolling: "touch", // ✅ smooth scroll (mobile too)
                                        background: '#f5f5f5'
                                    }}
                                ></div> : <></>}
                            </div>
                            <div className="form-row m-3 mt-2 mb-0 border-bottom" style={{ justifyContent: 'right' }}>
                                <div className="col-md-2 my-2" style={{ display: 'flex', marginRight: '3.5rem' }}>
                                    <button
                                        type="button"
                                        className="btn btn-aqua mx-2"
                                        data-bs-dismiss="modal"
                                        style={{ padding: '4px 15px', }}
                                        disabled={itiFile == '' || itiFile == null}
                                        onClick={e => this.uploadItinenary()}
                                    >
                                        Submit
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-gray"
                                        data-bs-dismiss="modal"
                                        style={{ padding: '4px 15px' }}
                                        onClick={e => this.setState({
                                            uploadPop: false, itiPath: '',
                                            itiFile: '',
                                            itiFiletype: '',
                                        })}
                                    >
                                        Cancel
                                    </button>
                                </div>


                            </div>
                            {/* <div className="modal-footer" style={{ padding: 3 }}>
                                                
                                                                            </div> */}
                        </div>
                    </div>

                </Modal >
            </>)
    }

}
export default withRouter(connect(null, { fill_action, getItineraryList_action, delegateItineraryPathAU_action })(DelegateItineraryList));